import { animations } from './animations';
import { aspectRatios } from './aspect-ratios';
import { blurs } from './blurs';
import { borders } from './borders';
import { colors } from './colors';
import { cursor } from './cursor';
import { durations } from './durations';
import { easings } from './easings';
import { fontSizes } from './font-sizes';
import { fontWeights } from './font-weights';
import { fonts } from './fonts';
import { letterSpacings } from './letter-spacings';
import { lineHeights } from './line-heights';
import { radii } from './radii';
import { shadows } from './shadows';
import { sizes } from './sizes';
import { spacing } from './spacing';
import { zIndex } from './z-index';

export const tokens = {
  aspectRatios,
  animations,
  blurs,
  borders,
  colors,
  durations,
  easings,
  fonts,
  fontSizes,
  fontWeights,
  letterSpacings,
  lineHeights,
  radii,
  shadows,
  spacing,
  sizes,
  zIndex,
  cursor,
};
